import Axios from "axios";
import {
    SET_HRM_EMPLOYEE_MEETING_LIST,
    UNSET_HRM_EMPLOYEE_MEETING_LIST,
    SET_EDITING_HRM_EMPLOYEE_MEETING,
    UNSET_EDITING_HRM_EMPLOYEE_MEETING,
} from "@/store/mutation-types";
import {
    getHrmEmployeeMeetingList,
    saveUpdateHrmEmployeeMeeting,
} from "@/store/api";

// initial state
const state = {
    getHrmEmployeeMeetingList: [],
    getEditingHrmEmployeeMeeting: null,
};

const getters = {
    getEditingHrmEmployeeMeeting(state) {
        return state.getEditingHrmEmployeeMeeting;
    },
    getHrmEmployeeMeetingList(state) {
        return state.getHrmEmployeeMeetingList;
    },
};

const mutations = {
    [SET_HRM_EMPLOYEE_MEETING_LIST](state, data) {
        state.getHrmEmployeeMeetingList = data;
    },
    [UNSET_HRM_EMPLOYEE_MEETING_LIST](state) {
        state.getHrmEmployeeMeetingList = [];
    },
    [SET_EDITING_HRM_EMPLOYEE_MEETING](state, data) {
        state.getEditingHrmEmployeeMeeting = data;
    },
    [UNSET_EDITING_HRM_EMPLOYEE_MEETING](state) {
        state.getEditingHrmEmployeeMeeting = null;
    },
};

const actions = {
    getHrmEmployeeMeetingList({ commit }, params) {
        return new Promise((resolve, reject) => {
            Axios.post(getHrmEmployeeMeetingList, params)
                .then(function (response) {
                    commit('SET_HRM_EMPLOYEE_MEETING_LIST', response.data.data || [])
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_HRM_EMPLOYEE_MEETING_LIST')
                    reject(error);
                });
        });
    },

    saveUpdateHrmEmployeeMeeting({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateHrmEmployeeMeeting, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};